/// <reference path="../../types.d.ts" />
import { state } from "./state";

export const I18N: Record<string, Record<string, string>> = {
  tr: {
    authEyebrow: "AİLE MİRASI BULUT SİSTEMİ",
    authSubtitle: "Soy ağacını görüntülemek veya düzenlemek için size verilen aile parolasını giriniz.",
    authPlaceholder: "Parola",
    authRemember: "Bu cihazda oturumu açık tut",
    authButton: "Soy Ağacını Aç",
    authDecrypting: "Yükleniyor...",
    authHint: "",
    authErrorInvalid: "Girdiğiniz parola hatalı. Lütfen tekrar deneyiniz.",
    searchPlaceholder: "İsim, soyadı veya doğum yılı ara... ( / )",
    navTree: "Soy Ağacı",
    navFan: "Yelpaze",
    navMap: "Harita",
    navDirectory: "Kişiler",
    navTimeline: "Zaman Çizelgesi",
    navKinship: "Akrabalık",
    navStats: "İstatistik",
    navArchive: "Belge Arşivi",
    navManage: "Yedek & Geçmiş",
    viewerModeBadge: "İzleyici",
    editorModeBadge: "Editör Açık",
    addPersonShort: "Kişi Ekle",
    branchesLabel: "Kök Kollar:",
    upGenLabel: "Üst:",
    downGenLabel: "Alt:",
    allGenOption: "Tümü",
    siblingsToggleOn: "Yan Kollar: Açık",
    siblingsToggleOff: "Yan Kollar: Gizli",
    spousesToggleOn: "Eşler: Açık",
    spousesToggleOff: "Eşler: Gizli",
    showFullBranchBtn: "Tüm Kolu Aç",
    printChartBtn: "İndir",
    focusedPersonLabel: "Odak Kişi:",
    viewProfileBtn: "Detay & Düzenle",
    addRelativeBtn: "Akraba Ekle",
    backBtn: "Geri",
    hudFitBtn: "Sığdır",
    hudFocusBtn: "Odak",
    legendMale: "Erkek",
    legendFemale: "Kadın",
    legendFocus: "Odak",
    legendLiving: "Dolu: Hayatta",
    legendDeceased: "İçi Boş: Vefat",
    legendSpouse: "Eş",
    legendBranch: "Alt Kol",
    fanTitle: "Yelpaze Çizelgesi:",
    fanModeLabel: "Yön:",
    fanDescendantsOpt: "Alt Soy (Çocuklar & Torunlar)",
    fanAncestorsOpt: "Üst Soy (Anne, Baba & Atalar)",
    fanRingsLabel: "Halka:",
    fanResetRootBtn: "Kök Ecdat",
    fanBackBtn: "Geri",
    fanProfileBtn: "Profil",
    fanColorLabel: "Renk:",
    fanColorBranch: "Soy Dalı",
    fanColorGender: "Cinsiyet",
    fanColorGeneration: "Kuşak",
    fanColorStatus: "Yaşam Durumu",
    fanLayoutLabel: "Dağılım:",
    fanLayoutBalanced: "Dengeli",
    fanLayoutEqual: "Eşit",
    mapTitle: "Tarihsel Göç Atlası:",
    mapBranchLabel: "Kol:",
    mapEventLabel: "Olay:",
    allBranchesOption: "Tüm Kollar",
    allEventsOption: "Tümü (Doğum & Vefat)",
    birthsOnlyOption: "Sadece Doğum Yerleri",
    deathsOnlyOption: "Sadece Vefat & Mezarlıklar",
    startStoryTourBtn: "Göç Hikayesi Turu",
    dirTitle: "Aile Kişi Rehberi ve Veri Yönetimi",
    addNewPersonBtn: "Yeni Kişi Ekle",
    mergePeopleBtn: "Kişileri Birleştir",
    findReplaceBtn: "Bul ve Değiştir",
    treeHealthBtn: "Sağlık Raporu",
    healthModalTitle: "🩺 Soy Ağacı Sağlık & Tutarlılık Raporu",
    healthModalSubtitle: "Soy ağacındaki tarih çelişkileri, imkansız ebeveyn yaşları, olası çift kayıtlar ve bağlantısız kişiler taranır.",
    healthScoreLabel: "Genel Sağlık Skoru",
    healthScorePerfect: "Mükemmel Veri Bütünlüğü",
    healthScoreGood: "İyi Durumda (Küçük Uyarılar)",
    healthScoreAttention: "İnceleme Gerekiyor",
    healthTabAll: "Tümü",
    healthTabErrors: "Kritik Hatalar",
    healthTabDuplicates: "Olası Çiftler",
    healthTabChronology: "Tarih & Yaş",
    healthTabIsolated: "İzole Kayıtlar",
    healthNoIssues: "Tebrikler! Soy ağacında herhangi bir tarih mantıksızlığı veya mükerrer kayıt tespit edilmedi.",
    healthFocusBtn: "Ağaçta Aç",
    healthEditBtn: "Düzenle",
    healthMergeBtn: "Birleştir",
    dirSearchPlaceholder: "İsim, soyadı, meslek, yer veya yıl filtrele...",
    allSurnamesOption: "Tüm Soyadları",
    allGendersOption: "Tüm Cinsiyetler",
    maleOption: "Erkek",
    femaleOption: "Kadın",
    allStatusOption: "Tüm Durumlar",
    livingOption: "Hayatta",
    deceasedOption: "Vefat Etmiş",
    sortDescendants: "Alt Soy Sayısı (Çoktan Aza)",
    sortName: "İsim (A - Z)",
    sortSurname: "Soyadı (A - Z)",
    sortBirthAsc: "Doğum Yılı (Eskiden Yeniye)",
    sortBirthDesc: "Doğum Yılı (Yeniden Eskiye)",
    timelineTitle: "Aile Kronolojik Zaman Çizelgesi",
    timelineSubtitle: "1870'lerden günümüze kaydedilen doğum, evlilik ve vefat olaylarının tarihsel akışı.",
    kinshipTitle: "Akrabalık ve Soy Bağı Hesaplayıcı",
    kinshipSubtitle: "Soy ağacındaki herhangi iki aile üyesini seçerek aralarındaki en kısa kan veya evlilik bağını adım adım görüntüleyin.",
    personALabel: "1. Aile Üyesi",
    personBLabel: "2. Aile Üyesi",
    pickPersonPlaceholder: "İsim yazarak arayın...",
    statsTitle: "Aile İstatistikleri ve Miras Özeti",
    topSurnamesTitle: "En Yaygın Soyadları (İlk 16)",
    topSurnamesHint: "Bir soyadına tıklayarak rehberde o kolu filtreleyebilirsiniz.",
    topRootsTitle: "En Geniş Soy Kolları (Kök Atalar)",
    topRootsHint: "Soy ağacında odaklamak için kişiye tıklayın.",
    topMaleNamesTitle: "En Çok Kullanılan Erkek İsimleri",
    topFemaleNamesTitle: "En Çok Kullanılan Kadın İsimleri",
    decadeBirthsTitle: "On Yıllara Göre Doğum Dağılımı",
    manageTitle: "Yedekleme, GEDCOM Dışa Aktarma ve Değişiklik Geçmişi",
    manageSubtitle: "Bulut veritabanındaki tüm güncellemeleri standart GEDCOM (.ged) veya JSON formatında indirebilir ve yapılan değişiklikleri geri alabilirsiniz.",
    auditLogTitle: "📜 Bulut Değişiklik Geçmişi (Audit Log)",
    auditLogHint: "Yapılan her ekleme ve düzenleme kaydedilir. Editör modunda tek tıkla geri alabilirsiniz.",
    deviceSessionsTitle: "🛡️ Cihaz Oturumları & Kalıcı Giriş",
    deviceSessionsHint: "Bu cihazda 1 yıl süreli kesintisiz oturum aktiftir. Şifreniz tarayıcıda asla düz metin olarak saklanmaz.",
    male: "Erkek",
    female: "Kadın",
    unknown: "Bilinmiyor",
    living: "Hayatta",
    deceased: "Vefat",
    born: "D.",
    died: "Ö.",
    focusBtn: "Odakla",
    focusInTreeBtn: "🌿 Ağaçta Odakla",
    editPersonBtn: "✎ Bilgileri Düzenle",
    addRelDrawerBtn: "＋ Akraba Ekle / Bağla",
    kinshipWithBtn: "🧭 Akrabalık Bul",
    copyLinkBtn: "🔗 Bağlantı Kopyala",
    copiedText: "✓ Kopyalandı",
    generationStat: "Kuşak",
    ancestorsStat: "Üst Ata",
    descendantsStat: "Alt Soy",
    parentsHeading: "Anne ve Baba",
    spousesHeading: "Eş(ler) ve Evlilik",
    siblingsHeading: "Kardeşler",
    childrenHeading: "Çocuklar",
    fatherRole: "Baba",
    motherRole: "Anne",
    spouseCurrent: "Evli",
    spouseDivorced: "Boşanmış",
    descendantsBadge: "alt soy",
    kpiTotalPeople: "Toplam Aile Üyesi",
    kpiTotalFamilies: "Aile / Evlilik Bağı",
    kpiSurnamesCount: "Farklı Soyadı",
    kpiEarliestBirth: "En Eski Kayıtlı Doğum",
    kpiMaxGenerations: "Kuşak Derinliği",
    kpiGenderSplit: "Kadın / Erkek Oranı",
    stepFather: "Babası",
    stepMother: "Annesi",
    stepParent: "Ebeveyni",
    stepSon: "Oğlu",
    stepDaughter: "Kızı",
    stepChild: "Çocuğu",
    stepSpouse: "Eşi",
    stepBrother: "Erkek Kardeşi",
    stepSister: "Kız Kardeşi",
    stepSibling: "Kardeşi",
    noConnection: "Bu iki kişi arasında doğrudan bir bağ bulunamadı.",
    samePerson: "Aynı kişiyi seçtiniz.",
    stepsDegree: "adım uzaklıkta",
  },
  en: {
    authEyebrow: "FAMILY HERITAGE CLOUD SYSTEM",
    authSubtitle: "Enter the family passcode to view or edit the family tree.",
    authPlaceholder: "Passcode",
    authRemember: "Keep me signed in on this device",
    authButton: "Open Family Tree",
    authDecrypting: "Loading...",
    authHint: "",
    authErrorInvalid: "Incorrect passcode. Please try again.",
    searchPlaceholder: "Search name, surname, or birth year... ( / )",
    navTree: "Tree Chart",
    navFan: "Fan Chart",
    navMap: "Map",
    navDirectory: "Directory",
    navTimeline: "Timeline",
    navKinship: "Kinship",
    navStats: "Statistics",
    navArchive: "Document Archive",
    navManage: "Backup & History",
    viewerModeBadge: "Viewer",
    editorModeBadge: "Editor Active",
    addPersonShort: "Add Person",
    branchesLabel: "Key Branches:",
    upGenLabel: "Up:",
    downGenLabel: "Down:",
    allGenOption: "All",
    siblingsToggleOn: "Siblings & Aunts: On",
    siblingsToggleOff: "Siblings & Aunts: Off",
    spousesToggleOn: "Spouses: On",
    spousesToggleOff: "Spouses: Off",
    showFullBranchBtn: "Expand All",
    printChartBtn: "Download",
    focusedPersonLabel: "Focused:",
    viewProfileBtn: "Details & Edit",
    addRelativeBtn: "Add Relative",
    backBtn: "Back",
    hudFitBtn: "Fit",
    hudFocusBtn: "Focus",
    legendMale: "Male",
    legendFemale: "Female",
    legendFocus: "Focused",
    legendLiving: "Solid: Living",
    legendDeceased: "Outline: Deceased",
    legendSpouse: "Spouse",
    legendBranch: "Branch",
    fanTitle: "Fan Chart:",
    fanModeLabel: "Direction:",
    fanDescendantsOpt: "Descendants (Children & Grandchildren)",
    fanAncestorsOpt: "Ancestors (Parents & Forebears)",
    fanRingsLabel: "Rings:",
    fanResetRootBtn: "Root Ancestor",
    fanBackBtn: "Back",
    fanProfileBtn: "Profile",
    fanColorLabel: "Colour:",
    fanColorBranch: "Lineage",
    fanColorGender: "Gender",
    fanColorGeneration: "Generation",
    fanColorStatus: "Living status",
    fanLayoutLabel: "Layout:",
    fanLayoutBalanced: "Balanced",
    fanLayoutEqual: "Equal",
    mapTitle: "Historical Migration Atlas:",
    mapBranchLabel: "Branch:",
    mapEventLabel: "Event:",
    allBranchesOption: "All Branches",
    allEventsOption: "All (Births & Deaths)",
    birthsOnlyOption: "Birthplaces Only",
    deathsOnlyOption: "Burials & Resting Places Only",
    startStoryTourBtn: "Migration Story Tour",
    dirTitle: "Family Member Directory & Data Management",
    addNewPersonBtn: "Add New Person",
    mergePeopleBtn: "Merge People",
    findReplaceBtn: "Find & Replace",
    treeHealthBtn: "Health Report",
    healthModalTitle: "🩺 Tree Health & Consistency Report",
    healthModalSubtitle: "Scans for chronological anomalies, impossible parent ages, duplicate candidates, and disconnected records.",
    healthScoreLabel: "Overall Health Score",
    healthScorePerfect: "Excellent Integrity",
    healthScoreGood: "Good (Minor Warnings)",
    healthScoreAttention: "Needs Review",
    healthTabAll: "All",
    healthTabErrors: "Critical Errors",
    healthTabDuplicates: "Potential Duplicates",
    healthTabChronology: "Date & Age",
    healthTabIsolated: "Isolated Records",
    healthNoIssues: "Congratulations! No chronological inconsistencies or duplicate records found in the tree.",
    healthFocusBtn: "Open in Tree",
    healthEditBtn: "Edit",
    healthMergeBtn: "Merge",
    dirSearchPlaceholder: "Filter by name, surname, place, or year...",
    allSurnamesOption: "All Surnames",
    allGendersOption: "All Genders",
    maleOption: "Male",
    femaleOption: "Female",
    allStatusOption: "All Statuses",
    livingOption: "Living",
    deceasedOption: "Deceased",
    sortDescendants: "Most Descendants",
    sortName: "Name (A - Z)",
    sortSurname: "Surname (A - Z)",
    sortBirthAsc: "Birth Year (Oldest First)",
    sortBirthDesc: "Birth Year (Newest First)",
    timelineTitle: "Chronological Family Timeline",
    timelineSubtitle: "Historical stream of recorded family births, marriages, and deaths from the 1870s to today.",
    kinshipTitle: "Kinship & Relationship Pathfinder",
    kinshipSubtitle: "Select any two relatives in the tree to discover the shortest blood or marriage path connecting them.",
    personALabel: "First Relative",
    personBLabel: "Second Relative",
    pickPersonPlaceholder: "Type a name to search...",
    statsTitle: "Family Statistics & Heritage Overview",
    topSurnamesTitle: "Most Common Surnames (Top 16)",
    topSurnamesHint: "Click any surname to filter the directory by that branch.",
    topRootsTitle: "Largest Ancestral Lineages (Root Ancestors)",
    topRootsHint: "Click any ancestor to focus the family tree on their branch.",
    topMaleNamesTitle: "Most Common Male Given Names",
    topFemaleNamesTitle: "Most Common Female Given Names",
    decadeBirthsTitle: "Birth Distribution by Decade",
    manageTitle: "Backups, GEDCOM Export & Change History",
    manageSubtitle: "Download all live cloud records as universal GEDCOM (.ged) or JSON, and review or undo recent edits.",
    auditLogTitle: "📜 Cloud Change History (Audit Log)",
    auditLogHint: "Every addition and edit is logged. In Editor mode, you can undo any change with one click.",
    deviceSessionsTitle: "🛡️ Device Sessions & Persistent Login",
    deviceSessionsHint: "A 1-year sliding session is active on this device. Passwords are never stored in plaintext.",
    male: "Male",
    female: "Female",
    unknown: "Unknown",
    living: "Living",
    deceased: "Deceased",
    born: "b.",
    died: "d.",
    focusBtn: "Focus",
    focusInTreeBtn: "🌿 Focus in Tree",
    editPersonBtn: "✎ Edit Details",
    addRelDrawerBtn: "＋ Add / Connect Relative",
    kinshipWithBtn: "🧭 Find Kinship",
    copyLinkBtn: "🔗 Copy Link",
    copiedText: "✓ Copied",
    generationStat: "Generation",
    ancestorsStat: "Ancestors",
    descendantsStat: "Descendants",
    parentsHeading: "Parents",
    spousesHeading: "Spouse(s) & Marriages",
    siblingsHeading: "Siblings",
    childrenHeading: "Children",
    fatherRole: "Father",
    motherRole: "Mother",
    spouseCurrent: "Married",
    spouseDivorced: "Divorced",
    descendantsBadge: "descendants",
    kpiTotalPeople: "Total Relatives",
    kpiTotalFamilies: "Families / Unions",
    kpiSurnamesCount: "Distinct Surnames",
    kpiEarliestBirth: "Earliest Birth Year",
    kpiMaxGenerations: "Generational Depth",
    kpiGenderSplit: "Female / Male Ratio",
    stepFather: "Father",
    stepMother: "Mother",
    stepParent: "Parent",
    stepSon: "Son",
    stepDaughter: "Daughter",
    stepChild: "Child",
    stepSpouse: "Spouse",
    stepBrother: "Brother",
    stepSister: "Sister",
    stepSibling: "Sibling",
    noConnection: "No direct path found between these two individuals.",
    samePerson: "You selected the same person.",
    stepsDegree: "steps apart",
  },
};

export function t(key: string): string {
  const lang = (state && state.lang) || "tr";
  return (I18N[lang] && I18N[lang][key]) || (I18N.tr && I18N.tr[key]) || key;
}
